module.exports = __webpack_public_path__ + "img/case-title.4fec1c41.png";